import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { times } from "lodash";
import { renderField, renderRadioButton } from "../components";

const Dependant = ({ renderValue, formId }) => (
  <Fragment>
    <span style={{ fontWeight: "bold" }}>
      {"(B) DEPENDANT'S INFORMATION (Please ignore this section if dependants are not covered)"}
    </span>
    <table style={{ borderCollapse: "collapse", width: "100%" }} className="normalPadded">
      <tbody>
        <tr>
          <td style={{ border: "1px solid #000" }}>Relationship</td>
          <td
            style={{
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Name
          </td>
          <td
            style={{
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Occupation
          </td>
          <td
            style={{
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            NRIC / Passport No.
          </td>
          <td
            style={{
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Nationality
          </td>
        
          <td
            style={{
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Country of Residence
          </td>
          <td
            style={{
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Sex
          </td>
          <td
            style={{
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Date of Birth
            <br />
            (DD / MM / YY)
          </td>
          <td
            style={{
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Height
            <br />
            (cm)
          </td>
          <td
            style={{
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Weight
            <br />
            (kg)
          </td>
        </tr>
        {times(4, count => {
          const dependantId = count + 1;
          return (
            <tr key={dependantId}>
              <td
                style={{
                  borderLeft: "1px solid #000",
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                }}
              >
                Dependant {dependantId}
              </td>
              <td
                style={{
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                }}
                id={`RO_Dep${dependantId}Name`}
              >
                {renderValue({ fieldName: `Dep${dependantId}Name`, fieldFormat: "text" })}
                <Field component={renderField} type="hidden" name={`Dep${dependantId}Name`} />
              </td>
              <td
                style={{
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                }}
              >
                <Field
                  name={`Dep${dependantId}JobTitle`}
                  type="text"
                  component={renderField}
                  style={{ width: "100%" }}
                />
              </td>
              <td
                style={{
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                }}
                id={`RO_Dep${dependantId}Identification`}
              >
                {renderValue({
                  fieldName: `Dep${dependantId}Identification`,
                  fieldFormat: "text",
                })}
              </td>
              <td
                style={{
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                }}
              >
                <Field
                  name={`Dep${dependantId}Nationality`}
                  type="text"
                  component={renderField}
                  style={{ width: "100%" }}
                />
              </td>
              
              <td
                style={{
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                }}
              >
                <Field
                  name={`Dep${dependantId}CountryOfResidence`}
                  type="text"
                  component={renderField}
                  style={{ width: "100%" }}
                />
              </td>
              <td
                style={{
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                }}
                id={`RO_Dep${dependantId}Gender`}
              >
                {renderValue({ fieldName: `Dep${dependantId}Gender`, fieldFormat: "text" })}
              </td>
              <td
                style={{
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                }}
                id={`RO_Dep${dependantId}BirthDate`}
              >
                {renderValue({
                  fieldName: `Dep${dependantId}BirthDate`,
                  fieldFormat: "date",
                  dateFormat: formId === "SINGLIFEHD202308" ? "DD/MM/YY" : "YYYY-MM-DD",
                })}
              </td>
              <td
                style={{
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                  textAlign: "center",
                }}
              >
                <Field
                  name={`Dep${dependantId}Height`}
                  type="text"
                  component={renderField}
                  style={{ width: 50 }}
                />
              </td>
              <td
                style={{
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                  textAlign: "center",
                }}
              >
                <Field
                  name={`Dep${dependantId}Weight`}
                  type="text"
                  component={renderField}
                  style={{ width: 50 }}
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <br />
  </Fragment>
);

Dependant.propTypes = {
  renderValue: PropTypes.func.isRequired,
  formId: PropTypes.string.isRequired,
};

export default Dependant;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aviva/SINGLIFEHD202308/Dependant.js